module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tuneMic":"Mic setup","helloMyNameIs":"Make sure the indicator reaches the green zone"}}')
  delete Component.options._Ctor
}
